<div class="modal-container main-font">
  <form [formGroup]="timeSheetForm" class="w-100">
    <div class="request-container">
      <div class="header-container">
        <p class="title-text">Richiesta cambio ore</p>
        <button class="transparent-btn close-btn" (click)="closeModal()">
          <i class="icons close fill-sev-grey-600"></i>
        </button>
      </div>
      <div class="table-container">
        <table class="w-100" *ngIf="projectsControl.length > 0; else noProject">
          <thead>
            <tr class="d-flex py-2">
              <th class="date-container align-items-center">
                <p class="mb-0 text-date">
                  Data:
                  <b>{{ timeSheetForm.value.date | date: 'dd-MM-yyyy' }}</b>
                </p>
              </th>
              <th class="type-header-container">
                <div class="d-flex align-items-center flex-column w-50">
                  <i class="icons scrum fill-svg-grey-600"></i>
                  <p class="mb-0 text-detail">Ore Capacity</p>
                </div>
                <div class="d-flex align-items-center flex-column w-50">
                  <i class="icons billing fill-svg-grey-600"></i>
                  <p class="mb-0 text-detail">Ore Fattutazione</p>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <div formArrayName="projects">
              <tr
                [formGroupName]="i"
                class="table-body-row"
                *ngFor="
                  let project of projectsControl;
                  let i = index;
                  let first = first;
                  let last = last
                ">
                <td
                  class="cell-project"
                  [ngStyle]="{
                    'border-radius': first ? '8px 0 0 0' : '',
                    'border-top': !first ? 'none' : ''
                  }">
                  <img src="" alt="" />
                  <p class="text-project mb-0">
                    {{ timeSheetsModal[i]?.alias }}
                  </p>
                  <p
                    class="text-danger mb-0 ms-1"
                    *ngIf="project.value.is_authorized && !isReadOnly">
                    *
                  </p>
                  <i
                    *ngIf="project.value.status == 'in_attesa'"
                    class="icons bell-request fill-svg-orange-300"></i>
                </td>
                <td
                  class="timesheet-cell"
                  [ngClass]="
                    project.value.status == 'in_attesa' ? 'request-pending' : ''
                  "
                  [ngStyle]="{
                    'border-radius': first ? '0 8px 0 0' : '',
                    'border-top': !first ? 'none' : ''
                  }">
                  <nz-time-picker
                    [nzDisabled]="
                      isReadOnly ||
                      isValueDisabled(project) ||
                      project.value.is_authorized
                    "
                    class="w-50"
                    formControlName="value"
                    [nzDisabledHours]="disabledHours"
                    [nzDisabledMinutes]="disabledMinutes"
                    [nzMinuteStep]="15"
                    nzFormat="HH:mm"
                    nzPlaceHolder="Tempo"
                    [nzNowText]="' '"
                    [nzAllowEmpty]="false"
                    [nzOkText]="'Salva'"></nz-time-picker>

                  <nz-time-picker
                    [nzDisabled]="
                      isReadOnly ||
                      isBillingValueDisabled(project) ||
                      project.value.is_authorized
                    "
                    class="w-50"
                    formControlName="billing_value"
                    [nzDisabledHours]="disabledHours"
                    [nzDisabledMinutes]="disabledMinutes"
                    [nzMinuteStep]="15"
                    nzFormat="HH:mm"
                    nzPlaceHolder="Tempo"
                    [nzNowText]="' '"
                    [nzAllowEmpty]="false"
                    [nzOkText]="'Salva'"></nz-time-picker>
                </td>
              </tr>
              <tr class="table-body-row">
                <td class="cell-project-total">
                  <p class="mb-0">Totale</p>
                </td>
                <td class="timesheet-cell-total">
                  <div class="w-50 text-center pills pills-cap">
                    <p class="mb-0 totals-text">{{ selectedTotal?.value }}</p>
                  </div>
                  <div class="w-50 text-center pills pills-fatt">
                    <p class="mb-0 totals-text">
                      {{ selectedTotal?.billing_value }}
                    </p>
                  </div>
                </td>
              </tr>
            </div>
          </tbody>
        </table>
        <app-alert
          *ngIf="!isReadOnly && haveUthorizedProjects()"
          message="(*) Per questi progetti non è necessaria una richiesta. Puoi modificare le ore dalla Home"></app-alert>
        <ng-template #noProject>
          <p class="mb-0 text-date">
            Non ci sono progetti disponibili per la quale puoi effettuare una
            richiesta.
          </p>
          <app-alert
            class="mb-4 w-100"
            [message]="
              'Assicurati di avere almeno un progetto con una sprint in corso'
            "></app-alert>
        </ng-template>
        <app-alert
          *ngIf="projectsControl.length > 0 && chosenUser == profileData.id"
          [message]="
            '* Per questi progetti non è necessaria una richiesta. Puoi modificare le ore dalla Home.'
          "></app-alert>
      </div>
    </div>
    <div class="note-container w-100 mt-2" *ngIf="projectsControl.length > 0">
      <p class="mb-0">Note</p>
      <nz-textarea-count [nzMaxCharacterCount]="250" class="w-100">
        <textarea
          [readOnly]="isReadOnly"
          [nzAutosize]="{ minRows: 4, maxRows: 4 }"
          formControlName="note"
          nz-input></textarea>
      </nz-textarea-count>
    </div>
    <div class="btn-container" *ngIf="projectsControl.length > 0">
      <button class="secondary-btn w-50" (click)="closeModal()">Annulla</button>
      <button
        class="w-50 primary-btn"
        [disabled]="
          isReadOnly
            ? false
            : getModifiedProjects().projects.length === 0 || hasFinishMaxHours()
        "
        (click)="
          isReadOnly ? confirmRequest(chosenUser!, dateHeader) : saveRequest()
        ">
        {{ isReadOnly ? 'Conferma' : 'Invia' }}
      </button>
    </div>
    <button
      *ngIf="projectsControl.length == 0"
      class="primary-btn w-100"
      (click)="closeModal()">
      Torna a timesheet
    </button>
  </form>
</div>
